package com.milta.core.localization

data class ProfileStrings(
    val screenTitle: String,
    val sectionPersonal: String,
    val labelFirstName: String,
    val labelLastName: String,
    val labelRole: String,
    val sectionLanguage: String,
    val labelLanguage: String,
    val changeLanguageButton: String,
    val languageDialogTitle: String,
    val languageDialogConfirm: String,
    val languageDialogCancel: String,
    val sectionPassword: String,
    val labelCurrentPassword: String,
    val labelNewPassword: String,
    val changePasswordButton: String,
    // Success messages
    val successLanguageUpdated: String,
    val successPasswordChanged: String,
    // Error messages
    val errorProfileNotFound: String,
    val errorCurrentPasswordRequired: String,
    val errorCurrentPasswordTooLong: String,
    val errorNewPasswordRequired: String,
    val errorNewPasswordTooShort: String,
    val errorNewPasswordTooLong: String,
    val errorLanguageRequired: String,
    val errorForbidden: String,
    val errorValidation: String,
    val errorGeneric: String,
    // New profile screen
    val signOut: String,
    val deleteAccount: String,
    val menuLanguage: String,
    val menuPassword: String,
    val menuSubscription: String,
    val menuPrivacy: String,
    val menuTerms: String,
    /** [com.milta.feature.profile.presentation.PrivacyScreen]/[com.milta.feature.profile.presentation.TermsOfUseScreen]
     * — prefix shown before the formatted `updatedAt` date, e.g. "Mis à jour le 10/09/2026". */
    val legalUpdatedAtPrefix: String,
    val linkedCodeLabel: String,
    val linkedCodeLoadError: String,
    val copyCode: String,
    val codeCopied: String,
    val modeOrganisation: String,
    val modeDriver: String,
    val roleDriver: String,
    val roleOrganisation: String,
    // Mode switch screen (MIL-54)
    val modeSwitchTitle: String,
    val modeSwitchHint: String,
    val switchToEnterprise: String,
    val switchToDriver: String,
    // Phone number change
    val menuPhone: String,
    val phoneOtpStepTitle: String,
    val successPhoneUpdated: String,
    // Delete account (MIL-19)
    val deleteAccountDialogTitle: String,
    val deleteAccountDialogMessage: String,
    val deleteAccountDialogConfirm: String,
    val deleteAccountOtpStepTitle: String,
    val deleteAccountConfirmButton: String,
    val errorLastEnterpriseOwner: String,
    // Logout guard when offline deliveries are still queued
    val logoutPendingWarningTitle: String,
    val logoutPendingWarningMessageSuffix: String,
    val logoutPendingWarningConfirm: String,
    val logoutPendingWarningCancel: String,
    // Mode switch guard while a route is actively in progress
    val modeSwitchActiveRouteWarningTitle: String,
    val modeSwitchActiveRouteWarningMessage: String,
    val modeSwitchActiveRouteWarningConfirm: String,
    val modeSwitchActiveRouteWarningCancel: String,
)
